import { makeObservable, observable, runInAction, reaction, toJS } from 'mobx';
import axios from "../utils/axios";
import {storeGet} from "../utils/functions";

class importStore {
  data={};
  options={};
  mapper={};
  submitting=false;
  last_uploaded_file=null;
  category_fields={fetching:false, inited: false, data:{}};
  analyze={fetching:false, inited: false, data:{}};
  submit_result=null;
  constructor(dataset) {
    makeObservable(this, {
      data: observable,
      options: observable,
      analyze: observable,
      category_fields: observable,
      mapper: observable,
      last_uploaded_file: observable,
      submitting: observable,
      submit_result: observable,
    });

    this.options.inputName=dataset.inputName

    if(dataset.data) {
      const json=JSON.parse(dataset.data);
      if(json) {
        this.data=json;
      }
    }
    if(this.data.category) {
      this.fetchCategoryFields();
    }
  }
  fetchCategoryFields() {
    storeGet(`/sysapi/category/${this.data.category}/fields`, this.category_fields);
  }
  setUseAsIndex(name) {
    runInAction(()=>{
      for(let i in this.mapper) {
        if(i === name) {
          this.mapper[i].use_as_index=true;
        } else {
          this.mapper[i].use_as_index=false;
        }
      }
    });
  }
  findCategoryField(csvItem) {
    let filtered=this.category_fields.data.filter((item)=>{
      const matches=csvItem.name.match(/\[([0-9a-zA-Z:_]+)\] (.*)/);
      if(csvItem.code_part == item.code || csvItem.name_part == item.code || (matches && (matches[1] === item.code) )) {
        return true;
      }
      return false;
    });
    if(filtered.length) {
      return filtered[0].code;
    }

    filtered=this.category_fields.data.filter((item)=> {
      const matches = csvItem.name.match(/\[([0-9a-zA-Z:_]+)\] (.*)/);
      if (csvItem.code_part == item.code || csvItem.name_part == item.name || csvItem.name_part == item.code || (matches && (matches[1] === item.code || matches[2] === item.name))) {
        return true;
      }
      return false;
    });
    if(filtered.length) {
      return filtered[0].code;
    }


    return "";
  }
  startImport() {
    if(this.submitting) {
      return false;
    }
    runInAction(()=>{
      this.submitting=true;
      this.submit_result=null;
    });
    axios.post(`/sysapi/category/${this.data.category}/importCsv`,{
      mapper:this.mapper,
      file:this.last_uploaded_file
    }).then((data)=>{
      runInAction(()=>{
        this.submitting=false;
        this.submit_result=data.data;
      });
    });
  }
  deleteTmpFile() {
    if(this.last_uploaded_file && this.last_uploaded_file.token) {
      axios.post("/sysapi/delete_tmp_file", {token: this.last_uploaded_file.token}).then((data) => {

      });
    }
  }
  closeImport() {
    this.deleteTmpFile();
    this.analyze.data = null;
    this.analyze.inited = false;
    this.mapper = {};
    this.data.tmp_file = null;
    if(typeof window.importListener !== "undefined") {
      window.importListener.push({"cmd":"close_import"});
    }
  }
  analyzeFile(tmpFile) {
    runInAction(() => {
      this.submit_result=null;
      this.analyze.fetching = true;
      this.last_uploaded_file = tmpFile;
    });
    axios.post("/sysapi/category/analyze_import_csv", tmpFile).then((data)=>{
      if(data.data.answer) {
        runInAction(() => {
          this.analyze.fetching = false;
          this.analyze.inited = true;
          this.analyze.data = data.data.answer;
          this.analyze.data.forEach((item)=>{
            this.mapper[item.name]={
              use_as_index:0,
              category_field_code: this.findCategoryField(item)
            }
          })
        });
      } else  {
        runInAction(()=>{
          this.analyze.fetching = false;
        });
      }
    })
  }
}

export default importStore;